import { UserDefinedRow } from "../model";

/**
 * Represents the logic for handling user-defined rows.
 */
export class UserDefinedRowLogic {
  /**
   * Returns a blank UserDefinedRow object with the specified rowIndex.
   *
   * @param rowIndex - The index of the row.
   * @returns A blank UserDefinedRow object.
   */
   public static getBlank(rowIndex: number): UserDefinedRow {
    return {
      rowIndex: rowIndex,
      rowType: null,
      count: null,
      price: null,
      message: null,
      data: {},
      accounting: {
        dimensions: []
      }
    };
  }
}
